import { BaseButton } from 'iebt-zing-storybook'
import React from 'react'
import { useSmartNavigateLegacy as useNavigate } from 'components/SmartLink'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { hasAccess } from 'sharedKernel/auth/behavior'
import { trans } from 'sharedKernel/i18n'
import { EventButtonsProps } from '../contract'
export const EditEventButton = ({ eventId, isOwner }: EventButtonsProps): JSX.Element => {
  const labels = {
    toolTipContent: trans('Editar')
  }
  const haveAccess = hasAccess('challenge', 'update')
  const navigate = useNavigate()
  if (!haveAccess) {
    return <></>
  }
  if (!isOwner) {
    return <></>
  }
  const handleEditEvent = (eventId: string): void => {
    navigate(`/hub/company/event/${eventId}/edit`)
  }
  const icon = <FontAwesomeIcon icon={['fas', 'pen']} size="xl" />
  return (
    <BaseButton
      btnContent={icon}
      variant="primary-invert"
      size="icon"
      tippyContent={labels.toolTipContent}
      onClick={() => {
        handleEditEvent(eventId)
      }}
    />
  )
}
